// The API has no pending state for historical setup, so an unconnected result is assumed final after this window
export const HISTORICAL_SETUP_TIMEOUT_MS = 3 * 60 * 1000;

/**
 * Whether a historical (orders / customers) setup check is still pending after a setup info refresh.
 * @param {{ pending: boolean, connected?: boolean | null, startedAt?: number | null, now?: number }} params
 */
export const isHistoricalSetupPending = ({ pending, connected, startedAt, now = Date.now() }) =>
    Boolean(pending && !connected && startedAt && now - startedAt < HISTORICAL_SETUP_TIMEOUT_MS);
